// ⚠️ CRITICAL – install global Leaflet LatLng/LatLngBounds safety patches
// BEFORE ANY OTHER MODULE runs (including react-leaflet, GoogleMutant, or any
// vendor chunk that caches a reference to the Leaflet constructors).  Installing
// here (main.tsx, first line) guarantees we patch the prototype chain before
// any map code runs and before any "Invalid LatLng (NaN,NaN)" can be thrown.
import { installLeafletLatLngPatches } from './utils/leafletLatLngPatches';
installLeafletLatLngPatches();

import './config/debug'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)